import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import ModalLayout from 'components/ModalLayout';
import Button from 'components/Button/Button';
import RestaurantsMultipleSelect from './components/RestaurantsMultipleSelect';
import ModalWindows from './components/ModalWindows';
import {
	CopyMenuModalContext,
	ICopyMenuModalContext,
} from './copyMenuModalContext/copyMenuModalState/copyMenuModalContext';
import { TTypeOfModalWindow } from '../../../dishesState/dishesContext';
import classNames from 'classnames';
import style from './CopyMenuModal.module.scss';

interface ICopyMenuModal {
	changeTypeOfModalWindow: (value: TTypeOfModalWindow) => void;
	isVisible: boolean;
}

const CopyMenuModal: React.FC<ICopyMenuModal> = ({ changeTypeOfModalWindow, isVisible }) => {
	const { setIDsRestaurantsToCopyMenu, changeTypeOfCopyMenuModalWindow, IDsSelectedRestaurantsToCopyMenu } =
		useContext<ICopyMenuModalContext>(CopyMenuModalContext);

	const buttonClasses = classNames(style.saveBtn, {
		[style.visible]: IDsSelectedRestaurantsToCopyMenu.length,
	});

	const handleCloseModal = () => {
		changeTypeOfModalWindow(null);
		setIDsRestaurantsToCopyMenu([]);
	};

	return (
		<ModalLayout setIsShowModal={handleCloseModal} isVisible={isVisible} width="50%">
			<div className={style.container} data-test="CopyMenuModal">
				<Text
					className={style.modalHeader}
					translationNameSpace="form"
					translationKey="copyMenuTitle"
					size="xxl"
					weight="bold"
					align="center"
				/>
				<div className={style.wrapper}>
					<div className={style.heading}>
						<Text
							translationNameSpace="form"
							translationKey="restaurantsHeading"
							theme="secondary"
							size="l"
							weight="bold"
							display="inline"
						/>
						<Text
							className={style.hint}
							translationNameSpace="form"
							translationKey="copyMenuHint"
							theme="secondaryLight"
							size="s"
							weight="bold"
							display="inline"
						/>
					</div>
					<RestaurantsMultipleSelect />
				</div>
				<Button
					className={buttonClasses}
					theme="primaryBlue"
					onClick={() => changeTypeOfCopyMenuModalWindow('toConfirmCopyMenu')}>
					<Text translationNameSpace="form" translationKey="saveButton" asFragment={true} />
				</Button>
			</div>
			<ModalWindows />
		</ModalLayout>
	);
};

export default React.memo(CopyMenuModal);
